export const FontFamily = 'Nunito, Helvetica, Arial, sans-serif';
function getFontDefinition(fontWeight, fontSize, lineHeight) {
    return {
        FontFamily: FontFamily,
        FontSize: fontSize,
        FontWeight: fontWeight,
        LineHeight: lineHeight,
    };
}
export var FontWeight;
(function (FontWeight) {
    FontWeight[FontWeight["Thin"] = 100] = "Thin";
    FontWeight[FontWeight["ExtraLight"] = 200] = "ExtraLight";
    FontWeight[FontWeight["Light"] = 300] = "Light";
    FontWeight[FontWeight["Regular"] = 400] = "Regular";
    FontWeight[FontWeight["Medium"] = 500] = "Medium";
    FontWeight[FontWeight["SemiBold"] = 600] = "SemiBold";
    FontWeight[FontWeight["Bold"] = 700] = "Bold";
    FontWeight[FontWeight["ExtraBold"] = 800] = "ExtraBold";
    FontWeight[FontWeight["Heavy"] = 900] = "Heavy";
})(FontWeight || (FontWeight = {}));
export const Size = {
    HugeTitleBold: getFontDefinition(FontWeight.ExtraBold, 64, 72),
    HugeTitle: getFontDefinition(FontWeight.SemiBold, 64, 88),
    LargeTitle: getFontDefinition(FontWeight.ExtraBold, 48, 64),
    DisplayLarge: getFontDefinition(FontWeight.ExtraBold, 36, 48),
    DisplayMedium: getFontDefinition(FontWeight.Bold, 28, 32),
    DisplaySmall: getFontDefinition(FontWeight.Bold, 20, 24),
    Heading: getFontDefinition(FontWeight.Bold, 18, 20),
    SubHeading: getFontDefinition(FontWeight.Bold, 16, 20),
    BodyLargeHeavy: getFontDefinition(FontWeight.SemiBold, 16, 20),
    BodyLarge: getFontDefinition(FontWeight.Regular, 16, 20),
    BodyHeavy: getFontDefinition(FontWeight.Bold, 14, 20),
    Body: getFontDefinition(FontWeight.SemiBold, 14, 20),
    SmallHeavy: getFontDefinition(FontWeight.Bold, 12, 16),
    Small: getFontDefinition(FontWeight.SemiBold, 12, 16),
    Badge: getFontDefinition(FontWeight.Medium, 8, 12),
};
//# sourceMappingURL=Typography.js.map